import React from "react";
import { useOutlet } from "react-router-dom";

/**
 * Keeps a list page mounted while one of its nested detail/manage routes is open.
 *
 * Why: normally React Router unmounts the index page when navigating to a child
 * route, so local list/search/pagination state is lost and the list API runs again
 * on back. Keeping the list mounted preserves that state without duplicating
 * snapshot logic in every screen.
 */
const PersistentListRoute = ({ element }) => {
  const outlet = useOutlet();
  const hasChildRoute = Boolean(outlet);

  return (
    <>
      <div style={{ display: hasChildRoute ? "none" : "contents" }}>
        {element}
      </div>
      {outlet}
    </>
  );
};

export default PersistentListRoute;
